module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aleg0-f83bca280f576fbe339f6378515d4692.jpg";